interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-emotion-sad-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="w-full flex flex-col items-center justify-center py-16 px-4 text-center">
      <span className="w-16 h-16 rounded-full bg-background-100 text-primary-500 flex items-center justify-center text-3xl mb-4">
        <i className={icon}></i>
      </span>
      <p className="text-base font-bold text-foreground-950">{title}</p>
      {description && (
        <p className="mt-2 text-sm text-foreground-600 max-w-md leading-relaxed">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}